import { render } from "./Program.vue?vue&type=template&id=81379c56&scoped=true"
import script from "./Program.vue?vue&type=script&lang=js"
export * from "./Program.vue?vue&type=script&lang=js"

import "./Program.vue?vue&type=style&index=0&id=81379c56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81379c56"]])

export default __exports__